// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import * as CryptoJS from 'crypto-js';
export const environment = {
  production: false,



  //   begin:: local --- IGNORE ---
  // API_URL: 'http://localhost:5001/api/',
  // SOCKET_URL: 'http://localhost:5001/',
  // BASE_URL: 'http://localhost:5001/',
  // CF_URL: 'https://d23oyd8gfm720i.cloudfront.net/fit-in/',
  // CF_PDF_URL: 'https://d23oyd8gfm720i.cloudfront.net/',
  // API_AUCT_URL: 'http://localhost:5001/api/',
  //  end:: local --- IGNORE ---


  //   begin:: feature --- IGNORE ---
  API_URL: 'https://alqaryahdevelopments.com/api/',
  SOCKET_URL: 'https://alqaryahdevelopments.com/',
  BASE_URL: 'https://alqaryah.online/',
  CF_URL: 'https://d23oyd8gfm720i.cloudfront.net/fit-in/',
  API_AUCT_URL: 'https://alqaryahdevelopments.com/api/',
CF_PDF_URL: "https://d23oyd8gfm720i.cloudfront.net/",
  //  end:: feature --- IGNORE ---

  //   begin:: dev --- IGNORE ---
  // API_URL: 'https://alqaryahdevelopment.com/api/',
  // SOCKET_URL: 'https://alqaryahdevelopment.com/',
  // BASE_URL: 'https://alqaryah.info/',
  // CF_URL: 'https://d23oyd8gfm720i.cloudfront.net/fit-in/',
  // CF_PDF_URL: "https://d23oyd8gfm720i.cloudfront.net/",
  // API_AUCT_URL: 'https://alqaryahdevelopment.com/api/',
  //  end:: dev --- IGNORE ---


  // begin:: Production --- IGNORE ---
  // API_URL: 'https://erpapi.alqaryahauction.com/api/',
  // SOCKET_URL: 'https://erpapi.alqaryahauction.com/',
  // BASE_URL: 'https://alqaryahauction.com/',
  // CF_URL: 'https://d38ysq0a2r9nxs.cloudfront.net/fit-in/',
  // API_AUCT_URL: 'https://erpapi.alqaryahauction.com/api/',
  // CF_PDF_URL: "https://d23oyd8gfm720i.cloudfront.net/",
  // end:: Production --- IGNORE ---

  firebase: {
    apiKey: 'AIzaSyBplLKx7qsDl7JEeB8FATccyLlV-asWyYQ',
    authDomain: 'al-qaryah-auction-6b2ae.firebaseapp.com',
    projectId: 'al-qaryah-auction-6b2ae',
    storageBucket: 'al-qaryah-auction-6b2ae.firebasestorage.app',
    messagingSenderId: '690813514559',
    appId: '1:690813514559:web:de144ad93ba3f59a73598a',
    measurementId: 'G-2GT29Q282C',
  },
};